var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('FooterSm',{staticClass:"footer-sm"}),_c('FooterMd',{staticClass:"footer-md"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }